<template>
  <b-dropdown-group class="node node-content">
    <b-dropdown-item @click="$emit('select', team)">
      <i class="org-icon mr-1" v-if="!team.parentId"></i>
      <i class="child-org-icon mr-1" v-else></i>
      <span v-no-capture>{{ team.name }}</span>
    </b-dropdown-item>
    <template v-for="child in team.children">
      <org-selector-dropdown-item
        :key="'children-' + child.id"
        :team="child"
        @select="$emit('select', $event)"
        v-if="team.children.length > 0"
      />
    </template>
  </b-dropdown-group>
</template>

<script>
import { BDropdownGroup, BDropdownItem } from 'bootstrap-vue'

export default {
  name: 'OrgSelectorDropdownItem',
  props: ['team'],
  components: {
    BDropdownGroup,
    BDropdownItem
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onSelect(team) {
      this.$emit('select', team)
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

@include treeNodeConnector(14px, -17px, 30px, -12px, $spacerLeftShift: 0);

.node .node {
  margin-left: 24px;
}

/deep/ .dropdown-item {
  transition: font-weight ease-out 100ms;
  &:focus,
  &:hover {
    background-color: inherit;
    font-weight: 600;
  }
}
</style>
